import React from 'react';
import HelpWalkthrough from '../shared/HelpWalkthrough';
import './helpStages.css';

// "How communications work" walkthrough with animated demo stages.

const Tick = ({ size = 9 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden><polyline points="20 6 9 17 4 12" /></svg>
);

/* 1 ── a reminder text landing, client replying */
const RemindersStage = () => (
  <div className="hs-float" style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start' }}>
    <div className="hs-bubble hs-rise" style={{ animationDelay: '0.15s', alignSelf: 'flex-end' }}>
      Hi Sophie, a reminder for your appointment tomorrow at 2:30pm
    </div>
    <div className="hs-bubble hs-bubble--grey hs-rise" style={{ animationDelay: '0.7s' }}>
      See you then! 💛
    </div>
    <span className="hs-chip hs-pop" style={{ background: 'rgba(0,126,160,0.1)', color: '#007EA0', animationDelay: '1.25s', alignSelf: 'center' }}>
      <Tick size={8} /> No-show avoided
    </span>
  </div>
);

/* 2 ── a trigger flowing into a designed email */
const CustomStage = () => (
  <div className="hs-float" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
    <span className="hs-chip hs-rise" style={{ background: '#fff', color: '#4B4B52', boxShadow: '0 6px 18px rgba(26,26,30,0.1)', padding: '8px 12px', fontSize: 10.5, animationDelay: '0.1s' }}>
      After first visit
    </span>
    <svg className="hs-rise" style={{ animationDelay: '0.45s' }} width="26" height="14" viewBox="0 0 26 14" fill="none" stroke="#8E8E93" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M1 7h21" /><path d="M17 1l6 6-6 6" />
    </svg>
    <div className="hs-email hs-pop" style={{ width: 104, animationDelay: '0.7s' }}>
      <div className="hs-email-hero" style={{ padding: '9px 9px 8px' }}>
        <span className="hs-line" style={{ width: 52, height: 6 }} />
      </div>
      <div className="hs-email-body" style={{ padding: '8px 9px 9px' }}>
        <span className="hs-line" style={{ width: '90%' }} />
        <span className="hs-line" style={{ width: '62%' }} />
        <span className="hs-btn-pill" style={{ width: 54, height: 13, marginTop: 7 }} />
      </div>
    </div>
  </div>
);

/* 3 ── stars filling, a review arriving */
const ReviewsStage = () => (
  <div className="hs-float" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
    <div style={{ display: 'flex', gap: 6 }}>
      {[0, 1, 2, 3, 4].map((i) => (
        <svg key={i} className="hs-star hs-pop" style={{ animationDelay: `${0.15 + i * 0.14}s` }} width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
        </svg>
      ))}
    </div>
    <div className="hs-panel hs-rise" style={{ width: 188, animationDelay: '0.95s' }}>
      <span className="hs-line" style={{ width: '94%' }} />
      <span className="hs-line" style={{ width: '70%' }} />
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, paddingTop: 8 }}>
        <span className="hs-avatar" style={{ background: '#C2557A', opacity: 0.85, width: 16, height: 16 }} />
        <span style={{ fontSize: 9.5, fontWeight: 700, color: '#4B4B52' }}>New Google review</span>
      </div>
    </div>
  </div>
);

/* 4 ── the monthly allowance refilling */
const SmsStage = () => (
  <div className="hs-float">
    <div className="hs-panel" style={{ width: 208, textAlign: 'left' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
          <span className="hs-rise" style={{ fontSize: 22, fontWeight: 800, letterSpacing: '-0.5px', color: '#29282D', animationDelay: '0.1s' }}>100</span>
          <span className="hs-rise" style={{ fontSize: 9.5, fontWeight: 700, color: '#8E8E93', animationDelay: '0.2s' }}>FREE SMS A MONTH</span>
        </div>
        <span className="hs-chip hs-pop" style={{ background: 'rgba(0,126,160,0.1)', color: '#007EA0', marginLeft: 'auto', animationDelay: '0.55s' }}>+20 each</span>
      </div>
      <div style={{ height: 10, borderRadius: 6, background: '#F2F2F7', overflow: 'hidden', marginTop: 9 }}>
        <span className="hs-bar" style={{ display: 'block', height: '100%', width: '72%', borderRadius: 6, background: 'linear-gradient(90deg, #007EA0, #00ACC9)', animationDelay: '0.4s' }} />
      </div>
      <p className="hs-rise" style={{ fontSize: 9.5, fontWeight: 600, color: '#8E8E93', margin: '8px 0 0', animationDelay: '0.8s' }}>
        20 more for each self-employed stylist
      </p>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 8 }}>
        <span className="hs-chip hs-pop" style={{ background: 'rgba(0,126,160,0.1)', color: '#007EA0', animationDelay: '1.05s' }}>Renews on the 1st</span>
        <span className="hs-chip hs-pop" style={{ background: '#F2F2F7', color: '#4B4B52', animationDelay: '1.2s' }}>Email always free</span>
      </div>
    </div>
  </div>
);

const SLIDES = [
  {
    key: 'reminders',
    title: 'Reminders that cut no-shows',
    body: 'Automatic texts and emails before every appointment, plus booking and sales updates, keep clients informed without you lifting a finger.',
    Stage: RemindersStage,
  },
  {
    key: 'custom',
    title: 'Your own custom automations',
    body: 'Create automations on your own triggers, like a follow-up after a first visit. Design the email with the full email designer, or keep it simple text.',
    Stage: CustomStage,
  },
  {
    key: 'reviews',
    title: 'Grow your reviews on autopilot',
    body: 'The review booster invites happy clients to leave a Google review after their visit, at just the right moment.',
    Stage: ReviewsStage,
  },
  {
    key: 'sms',
    title: 'A free SMS allowance every month',
    body: 'Your salon gets 100 free texts every month, plus 20 more for each self-employed stylist whose marketing you manage. The allowance renews on the 1st, and email is always free.',
    Stage: SmsStage,
  },
];

const CommunicationsHelp = ({ onClose }) => (
  <HelpWalkthrough eyebrow="How communications work" slides={SLIDES} onClose={onClose} />
);

export default CommunicationsHelp;
